import React, { useEffect, useRef, useState } from 'react'
import ResetFlowOverlay from './ResetFlowOverlay'
import { createFlowUiController } from '../../utils/localReset/flowUiController'
import { performLogout } from '../../utils/localReset/performLogout'
import { describeFailure } from '../../utils/localReset/messages'

// Host do SAIR. Monta o overlay e roda performLogout (a ÚNICA implementação de logout).
// Sucesso: avisa o Redux (onLoggedOut) e vai para /login. Falha: mostra por que e que nada foi apagado.
export default function LogoutFlow({
  onLoggedOut,
  onClose,
  performLogoutFn = performLogout,
  navigate = (url) => window.location.assign(url),
}) {
  const [controller] = useState(() => createFlowUiController('saida'))
  const started = useRef(false)

  useEffect(() => {
    if (started.current) return
    started.current = true
    ;(async () => {
      const result = await performLogoutFn({ ui: controller.ui })
      if (result.success) {
        try {
          await onLoggedOut?.()
        } catch {
          /* a sessão local já foi apagada */
        }
        navigate('/login')
      } else {
        controller.actions.fail(describeFailure(result))
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ResetFlowOverlay
      controller={controller}
      title='Saindo do ProGERAR'
      onClose={onClose}
    />
  )
}
